import {UserListView} from './view';
import {User} from '../../graphql';

interface UserListContainerProps {
  users: Array<User>;
}

export const UserListContainer = (props: UserListContainerProps) => {
  return <UserListView users={props.users}/>;
}
